(function () {
  const STORAGE_KEY = 'trp_selected_plan';
  const PETS_PAGE = '/pages/that-red-patch-for-pets';
  const DEFAULT_CTA_PACK = '10';
  const LEGACY_OFFER_HASHES = new Set(['#trp-home-products', '#trp-home-subscribe']);
  const PEOPLE_URLS = {
    2: '/products/that-red-patch-2-pack',
    5: '/products/that-red-patch-5-pack',
    10: '/products/that-red-patch-10-pack',
    20: '/products/that-red-patch-20-pack',
  };

  function selectedAudience() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'onetime' ? 'pets' : 'people';
    } catch (error) {
      return 'people';
    }
  }

  function packFromValue(value) {
    const match = String(value || '').match(/(?:^|\D)(2|5|10|20)(?:\s*-?\s*patch|\D|$)/i);
    return match ? match[1] : '';
  }

  function packForElement(element) {
    const productCard = element.closest('product-card');
    const customCard = element.closest('[data-trp-pack-handle], .trp-home-plan-cards article');

    return (
      element.dataset.trpPack ||
      packFromValue(productCard && productCard.dataset.productHandle) ||
      packFromValue(customCard && customCard.dataset.trpPackHandle) ||
      packFromValue(customCard && customCard.textContent) ||
      packFromValue(element.getAttribute('alt')) ||
      packFromValue(element.textContent)
    );
  }

  function audienceForElement(element) {
    const explicitContext = element.closest('[data-trp-audience-context], [data-product-grid]');
    if (explicitContext) {
      const audience = explicitContext.dataset.trpAudienceContext || explicitContext.dataset.productGrid;
      if (['people', 'pets'].includes(audience)) return audience;
    }

    return selectedAudience();
  }

  function targetFor(element, pack) {
    return audienceForElement(element) === 'pets'
      ? `${PETS_PAGE}?pack=${pack}`
      : PEOPLE_URLS[pack];
  }

  function rememberPack(pack) {
    try {
      sessionStorage.setItem('trp_selected_pack', pack);
    } catch (error) {}
  }

  function navigate(element) {
    const pack = packForElement(element);
    const target = pack && targetFor(element, pack);
    if (!target) return;

    rememberPack(pack);
    window.location.assign(target);
  }

  function makeInteractive(element) {
    if (!element || element.dataset.trpAudienceLinkReady === 'true') return;

    const pack = packForElement(element);
    if (!pack || !PEOPLE_URLS[pack]) return;

    element.dataset.trpAudienceLinkReady = 'true';
    element.dataset.trpPack = pack;
    element.classList.add('trp-audience-product-link');

    if (element.tagName === 'A') {
      element.href = targetFor(element, pack);
      element.addEventListener('click', function () {
        rememberPack(pack);
      });
      return;
    }

    element.setAttribute('role', 'link');
    element.setAttribute('tabindex', '0');
    element.setAttribute('aria-label', `View ${pack}-Patch Pouch`);
    element.addEventListener('click', function () {
      navigate(element);
    });
    element.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      navigate(element);
    });
  }

  function isAddToCartControl(element) {
    return Boolean(
      element.closest(
        '[data-trp-plan-atc], [data-add-to-cart], product-form, form[action*="/cart/add"], .product-form'
      )
    );
  }

  function isLegacyOfferLink(element) {
    if (!element || element.tagName !== 'A' || isAddToCartControl(element)) return false;

    const href = element.getAttribute('href');
    if (!href) return false;

    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin && LEGACY_OFFER_HASHES.has(url.hash);
    } catch (error) {
      return false;
    }
  }

  function makePdpCta(element) {
    if (!isLegacyOfferLink(element)) return;

    if (!packForElement(element)) {
      element.dataset.trpPack = DEFAULT_CTA_PACK;
    }

    makeInteractive(element);
  }

  function enhance(root) {
    const scope = root && root.querySelectorAll ? root : document;

    if (scope.matches) {
      if (scope.matches('a')) {
        makePdpCta(scope);
      }
      if (scope.matches('.trp-home-plan-cards__top img, .trp-home-plan-cards__top h3')) {
        makeInteractive(scope);
      }
      if (scope.matches('.trp-prodcard .trp-u-061 img, .trp-prodcard .trp-u-064')) {
        makeInteractive(scope);
      }
      if (scope.matches('product-card')) {
        const link = scope.querySelector('.product-card__link');
        if (link) makeInteractive(link);
      }
    }

    scope.querySelectorAll('a').forEach(makePdpCta);
    scope.querySelectorAll('.trp-home-plan-cards__top img, .trp-home-plan-cards__top h3').forEach(makeInteractive);
    scope.querySelectorAll('.trp-prodcard .trp-u-061 img, .trp-prodcard .trp-u-064').forEach(makeInteractive);

    scope.querySelectorAll('product-card').forEach(function (card) {
      const link = card.querySelector('.product-card__link');
      if (link) makeInteractive(link);
    });
  }

  function refreshLinks() {
    document.querySelectorAll('a.trp-audience-product-link').forEach(function (link) {
      const pack = packForElement(link);
      if (pack) link.href = targetFor(link, pack);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhance(document);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) enhance(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener('pageshow', refreshLinks);
})();
